import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../../styles/Form.css";
import AWS from "../../../utils/awsConfig.js";
import CustomProductForm from "../../../../src/pages/managements/products/CustomProductform.js";
import { FIELDS, MODE, TOAST_MESSAGES } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const AddNews = () => {
  const navigate = useNavigate();
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  // Fields specific to news
  const newsFields = [
    {
      label: FIELDS.TITLE,
      name: "title",
      placeholder: "Enter Title",
      required: true,
    },
    {
      label: FIELDS.DESCRIPTION,
      name: "description",
      placeholder: "Enter Description",
      required: true,
      type: "rich-text",
    },
  
    {
      label: FIELDS.IMAGE,
      name: "image",
      type: "file",
      multiple: false,
    },
  ];

  const handleImageUpload = async (file) => {
    const s3 = new AWS.S3();
    const params = {
      Bucket: "solar-station",
      Key: `${Date.now()}_${file.name}`,
      Body: file,
      ACL: "public-read",
    };

    try {
      const { Location } = await s3.upload(params).promise();
      return Location;
    } catch (error) {
      toast.error("Error uploading image: " + error.message);
      throw error;
    }
  };

  const handleSubmit = async (formData) => {
    try {
      if (imageFiles.length > 0) {
        const uploadedImageUrl = await handleImageUpload(imageFiles[0]);
        formData.image = uploadedImageUrl;
      }

      await axios.post(`${API_URL}/news/createNews`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      toast.success(TOAST_MESSAGES.DATA_SAVED);
      navigate("/news");
    } catch (error) {
      toast.error(TOAST_MESSAGES.ERROR_ADD);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFiles([file]);
    const preview = URL.createObjectURL(file);
    setImagePreviews([preview]);
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add News
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/news")}
        >
          &times;
        </button>
      </div>
      <CustomProductForm
        mode={MODE.ADD}
        onSubmit={handleSubmit}
        fields={newsFields}
        imagePreview={imagePreviews}
        handleImageChange={handleImageChange}
      />
    </div>
  );
};

export default AddNews;
